export default () => ({
    first_name: "",
    last_name: "",
    status: true,
    roles:[],
    email:"",
    companies: []
  });